import { Field, FieldProps } from 'formik';
import React, { ChangeEvent } from 'react';
import { getTranslate } from 'react-localize-redux';
import { formikValidate } from '../../../../helpers/validation';
import FormItemLayout from '../../../../ui/Forms/FormItemLayout';
import TextField from '../../../../ui/TextField/TextField';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { icon } from '../../helpers';
import useRenderValidText from '../../../../custom-hooks/useRenderValidText';

const validateNameField = (value: string) => {
  if (value) {
    return formikValidate.socialMediaFields(value);
  }
  return;
};

const socialFields: Array<{ label: string; name: string }> = [
  { label: 'Facebook', name: 'FacebookUrl' },
  { label: 'Foursquare', name: 'FourSquareUrl' },
  { label: 'Instagram', name: 'InstagramUrl' },
  { label: 'Pinterest', name: 'PintrestUrl' },
  { label: 'Tripadvisor', name: 'TripAdvisorUrl' },
  { label: 'Twitter', name: 'TwitterUrl' },
  { label: 'Yelp', name: 'YelpUrl' },
];

type InnerProps = MappedState;
type OuterProps = {};
type Props = InnerProps & OuterProps;
const SocialMediaFields = ({ translate }: Props) => {
  return (
    <>
      {socialFields.map(({ label, name }, idx) => {
        return (
          <FormItemLayout key={idx} label={label} bottomBorder>
            <Field name={name} validate={validateNameField}>
              {({ field, form }: FieldProps) => {
                const { errors, touched, isSubmitting } = form;
                const fieldError = errors[field.name] as string | undefined;
                const showError = !!fieldError && (touched[field.name] as boolean | undefined);
                const helperText = useRenderValidText({
                  fieldError,
                  showError,
                  touched: !!touched[field.name],
                  value: field.value,
                });

                return (
                  <TextField
                    value={field.value}
                    fdKey={name}
                    autoComplete="off"
                    fullWidth
                    style={{ paddingRight: 16 }}
                    placeholder={translate('Enter_url') as string}
                    disabled={isSubmitting}
                    error={showError}
                    helperText={helperText}
                    FormHelperTextProps={{
                      children: ' ', // reserves line height for error message
                      style: { textAlign: 'right' },
                    }}
                    inputProps={{ style: { paddingTop: 0 } }}
                    InputProps={{
                      endAdornment: icon(
                        showError,
                        touched[field.name] as boolean,
                        field.value[field.name]
                      ),
                    }}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      form.setFieldValue(field.name, e.target.value);
                    }}
                  />
                );
              }}
            </Field>
          </FormItemLayout>
        );
      })}
    </>
  );
};

type MappedState = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: AppState) => ({
  translate: getTranslate(state),
});

export default compose<InnerProps, OuterProps>(connect(mapStateToProps))(SocialMediaFields);
